import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{staticClass:"layout-default pa-0",attrs:{"fluid":""}},[_c('SideMenu',{staticClass:"sidemenu"}),(_vm.isUserDataDispatchedToStore)?_c('router-view'):_vm._e(),_c('ButtonToTop',{attrs:{"showTopButton":_vm.showTopButton}}),_c('notifications',{attrs:{"group":"network","position":"bottom right","classes":"notification-dash","duration":-1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }